import {sendCustomMetric} from '@github-ui/stats'

export const applyInsertBeforePatch = () => {
  if (typeof Node === 'function' && Node.prototype) {
    const originalInsertBefore = Node.prototype.insertBefore
    let hasReportedExternalDomMutation = false

    const reportExternalDomMutation = () => {
      if (hasReportedExternalDomMutation) return
      hasReportedExternalDomMutation = true

      try {
        sendCustomMetric({
          name: 'BROWSER_EXTERNAL_DOM_MUTATION_PREVENTED',
          value: 1,
          tags: {patch: 'insert_before'},
        })
      } catch {
        // Metrics must not interfere with DOM operations.
      }
    }

    Node.prototype.insertBefore = function <T extends Node>(node: T, child: Node | null): T {
      if (child != null && child.parentNode !== this) {
        reportExternalDomMutation()
        return node
      }

      // @ts-expect-error some subtyping constraints
      return originalInsertBefore.apply(this, [node, child])
    }
  }
}
